<div class="home-container">
Overview of assignments or stats. 
<br>
list assignments/requets that require approval by managers


</div>